import { Address } from "./address.model";
import { Contact } from "./contact.model";

export interface FacilityDetail {
    id: number;
    year: number;
    facilityId: number;
    officialName: string;
    siccode: string;
    triid: string;
    employeeCount: number;
    dunBradstreetCode: string;
    parentName: string;
    parentDunBradstreetCode: string;
    technicalContactId?: number;
    publicContactId?: number;
    mailingAddressId?: number;
    realAddressId?: number;
    corporateDivision: string;
    customerId: number;
    isNew?: boolean;
    active: boolean;
    hasWasteTreatments: boolean;
    hasWaterBodies: boolean;
    hasPublicallyOwnedTreatmentWorks: boolean;
    hasOffsiteLocations: boolean;
    createdDateTime?: Date;
    updatedDateTime?: Date;
    technicalContact?: Contact;
    publicContact?: Contact;
    mailingAddress?: Address;
    realAddress?: Address;
    completedDateTime?: Date;
    completedBy?: number;
    completedByName?: string;
    status?: FacilityDetailStatus;
}

export enum FacilityDetailStatus {
    Active = 0,
    Locked = 1,
    Unpaid = 2
}
